<template lang="pug">
v-slide-y-transition(mode="out-in")
  v-container(fluid)
    confirm(ref="confirmPopup")

    v-toolbar.mb-3(dark, color="primary", v-if="!sortingMode")
      v-text-field(
        append-icon="search",
        :elevation="1",
        label="Filtrar",
        @keyup="handleSearchKeyUp",
        single-line,
        hide-details,
        v-model="search"
      )
      v-btn.right(text, to="/sales/create") Añadir nueva oferta
      v-btn.right(text, to="/sales_categories/create") Añadir nueva categoría

    v-toolbar.mb-3(elevation="0", v-else)
      v-btn.ml-auto(color="primary", @click="sortingMode = false") Terminar de ordenar

    div(v-if="sortingMode")
      v-list.elevation-1
        draggable(v-model="sortingSales", @end="handleSort")
          v-list-item.elevation-2.mx-3.my-2(
            v-for="item in sortingSales",
            :key="item.id"
          ) {{ item.name }}

      div {{ sorting }}

    div(v-else, v-for="category in salesCategories", :key="category.id")
      h2.mb-1.mt-2.title
        span {{ category.name }}
        v-btn.ml-2(text, @click="activateSorting(category)") Ordenar

      v-data-table.elevation-1(
        :loading="loading",
        :headers="tableHeaders",
        :search="search",
        :items="category.sales",
        disable-pagination,
        hide-default-footer
      )
        template(v-slot:item.price="{ item }") {{ (item.price / 100) | currency }}
        template(v-slot:item.visible="{ item }")
          v-icon(v-if="item.visible") check
          v-icon(v-else) close
        template(v-slot:item.options="{ item }")
          v-btn(:to="`/sales/${item.id}/edit`", text, icon, color="primary")
            v-icon edit
          v-btn(@click="handleDelete(item)", text, icon, color="red")
            v-icon delete
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'Sales',
  components: {
    draggable,
  },
  data() {
    return {
      search: null,
      sortingMode: false,
      sortingCategoryId: null,
      sortingSales: [],
      rowsPerPage: [25, 50, 100, { text: 'Todo', value: -1 }],
      sorting: null,
      salesCategories: [],
      loading: false,
      tableHeaders: [
        {
          text: 'Nombre',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Precio',
          align: 'right',
          sortable: false,
          width: '120px',
          value: 'price',
        },
        {
          text: 'Visible',
          align: 'center',
          width: '120px',
          sortable: false,
          value: 'visible',
        },
        {
          text: 'Opciones',
          align: 'right',
          width: '120px',
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    isLoading() {
      return this.loading;
    },
    activateSorting(category) {
      this.sortingSales = category.sales;
      this.sortingCategoryId = category.id;
      this.sortingMode = true;
    },
    fetchData() {
      this.loading = true;
      api
        .get('/sales_categories')
        .then((res) => {
          this.salesCategories = res.data;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearchKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.fetchPage(0, this.search);
      }
    },
    handleSort() {
      const sort = this.sortingSales.map((sale, i) => ({
        id: sale.id,
        position: i + 1,
      }));
      const index = this.salesCategories.findIndex(
        s => s.id === this.sortingCategoryId,
      );
      this.salesCategories[index].sales = this.sortingSales;
      api.put('/sales/sort', sort).catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
    },
    handleDelete(item) {
      this.$refs.confirmPopup
        .open('Eliminar', '¿Estás seguro?')
        .then((confirm) => {
          if (confirm) {
            api
              .delete(`/sales/${item.id}`)
              .then(() => {
                this.sales.splice(this.sales.indexOf(item), 1);
              })
              .catch(this.handleError);
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Sales/Sales.vue